<!-- Haupt-Template der Anwendung ohne Layout -->
<router-outlet></router-outlet>
<router-outlet name="popup"></router-outlet>
